import User from '../user';
import { notify } from 'reapop';

/**
 * Create the action
 */

const { thunk, request, success, error } = User.store((data, fetch, dispatch) => {
    return fetch.post('auth/register', data).then((response) => {
        return response;
    })
        .catch(err => {

            if (err.response.data.errors) {
                let returnedErrors = err.response.data.errors;
                let errors = [];
                let keys = Object.keys(returnedErrors);
                keys.forEach((key) => {
                    errors = errors.concat(returnedErrors[key]);
                });
                let message = '<ul>';
                errors.forEach((error) => {
                    message += `<li>${error}</li>`;
                });
                message += '</ul>';
                dispatch(notify({
                    title: 'Er ging iets mis',
                    message: message,
                    dismissible: true,
                    allowHTML: true,
                    status: 'error',
                    position: 'tc'
                }));
            } else {
                dispatch(notify({
                    message: 'Er is iets mis gegaan',
                    dismissible: true,
                    status: 'error',
                    position: 'tc'
                }));
            }
            dispatch(error(err));
            throw err;
        });
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };